import { Link } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { routes } from '@/router'
import { useContext } from 'react'
import { ProductContext } from '@/context/product/use-product'
import { HeaderPortal } from '@/components/layouts/app-layout/header-slot'

interface PageHeaderProps {
  children: React.ReactNode
  rollbackRoute?: string
}

export function PageHeaderContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <HeaderPortal>
      <Box sx={{ py: { xs: 2, md: 4 }, width: '100%' }}>{children}</Box>
    </HeaderPortal>
  )
}

export function PageHeader({ children, rollbackRoute }: PageHeaderProps) {
  const product = useContext(ProductContext)
  const home =
    product?.product === 'credit'
      ? routes.credit.index
      : routes.accounting.index

  return (
    <PageHeaderContainer>
      <Typography variant="h4" textAlign="center" position="relative">
        <IconButton
          component={Link}
          to={rollbackRoute || home}
          color="primary"
          sx={{ position: 'absolute', left: 0, mt: -1 }}
        >
          <ArrowBack />
        </IconButton>

        {children}
      </Typography>
    </PageHeaderContainer>
  )
}
